import React from 'react';
import Button from '../../../components/ui/Button';

const TimeRangeFilter = ({ selectedRange, onRangeChange }) => {
  const ranges = [
    { value: 'today', label: 'Today' },
    { value: '7days', label: '7 Days' },
    { value: '30days', label: '30 Days' },
    { value: '90days', label: '90 Days' },
    { value: 'year', label: 'This Year' },
    { value: 'all', label: 'All Time' }
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      {ranges?.map((range) => (
        <Button
          key={range?.value}
          variant={selectedRange === range?.value ? 'default' : 'outline'}
          size="sm"
          onClick={() => onRangeChange(range?.value)}
        >
          {range?.label}
        </Button>
      ))}
    </div>
  );
};

export default TimeRangeFilter;